var map = {
	"./aparthotelclub/ic_tag_rating.png": 69376,
	"./beachful/ic_tag_rating.png": 75425,
	"./castlepedia/ic_tag_rating.png": 51097,
	"./cocktayl/ic_tag_rating.png": 78519,
	"./ic_tag_rating.png": 87537,
	"./luxresortclub/ic_tag_rating.png": 29533,
	"./parkful/ic_tag_rating.png": 13226,
	"./prefabworld/ic_tag_rating.png": 88452,
	"./rooftopclub/ic_tag_rating.png": 47716,
	"./spaclub/ic_tag_rating.png": 68162,
	"./worldcasino/ic_tag_rating.png": 71147,
	"./zoopedia/ic_tag_rating.png": 38581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1004;